<template>
  <div :class="{'spl-table-problem-report-list__row-selected': !isSelected}" class="spl-table-problem-report-list__row">
    <div
      v-if="isSelected"
      class="spl-table-problem-report-list__deselect"
      @click="toggleSelected" />
    <div v-if="isSelected">
      <div
        v-for="(columnGroup, columnGroupIndex) in columnGroups"
        :key="'problemReportListRowColumnGroup' + columnGroupIndex"
        class="spl-table-problem-report-list__columngroup">
        <div
          v-for="(column, columnIndex) in columnGroup"
          :key="'problemReportListRowColumn' + columnIndex"
          :class="columnClasses(column, columnGroupIndex, columnGroup.length)"
          class="spl-table-problem-report-list__row__column">
          {{ column.value }}
        </div>
      </div>
    </div>
    <div v-if="!isSelected" class="spl-table-problem-report-list__row__deselected row">
      <div class="spl-table-problem-report-list__row__deselected__label">
        Parcel with <strong>Counter No. {{ columnGroups[0][0].value }}</strong> successfully deleted from problem report
      </div>
      <div class="spl-table-problem-report-list__row__deselected__restore" @click.stop.prevent="toggleSelected">
        Restore
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProblemReportListRow',
  props: [
    'columnGroups',
    'isSelected',
    'index'
  ],
  methods: {
    toggleSelected () {
      this.$emit('rowClicked', this.index)
    },
    columnClasses (column, index, columnGroupLength) {
      const classes = []

      if (column.statusClass) classes.push('spl-table-problem-report-list__status-' + column.statusClass)
      if (column.bold) classes.push('spl-table-problem-report-list__row__column-bold')
      if (column.doublewide) classes.push('spl-table-problem-report-list__column-doublewide')
      if (index === columnGroupLength - 1) classes.push('spl-table-problem-report-list__white-border')

      return classes.join(' ')
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-table-problem-report-list__row {

        &:after {
            clear: both;
            content: '';
            display: block;
            float: none;
        }
        &:nth-child(odd) {
            .spl-table-problem-report-list__row__column {
                background-color: $tableRowBackgroundColorAlt;
            }
        }
        &.spl-table-problem-report-list__row-selected {
            .spl-table-problem-report-list__row__column {
                background-color: #fff;
            }
        }
        &:hover {
            .spl-table-problem-report-list__row__column {
                background-color: $tableRowBackgroundColorHover;
            }
        }
        &__deselected {
            float: left;
            height: $tableRowHeight;
            line-height: $tableRowHeight;
            padding: 0 0 0 $mainPadding + 12px;
            min-width: 700px;
            width: 100%;

            &__label {
                color: $tableHeaderColor;
                float: left;
                font-size: 12px;
                min-width: 500px;
                width: 50%;

                strong {
                    font-weight: 700;
                }
            }
            &__restore {
                background-image: url(../../assets/icon-restore.svg);
                background-position: left center;
                background-repeat: no-repeat;
                color: $middleYellow;
                cursor: pointer;
                float: right;
                font-size: 13px;
                font-weight: 600;
                height: $tableRowHeight;
                margin: 0 auto;
                padding-left: 35px;
                width: 90px;
            }
        }
        &__column {
            background-color: $tableRowBackgroundColor;
            border-top: 2px solid #fff;
            color: $tableHeaderColor;
            float: left;
            font-size: 12px;
            height: $tableRowHeight;
            line-height: 17px;
            padding: 9px 12px;
            transition: background-color $shortTransition ease-in-out;
            width: $parcelListColumnWidth;

            &-bold {
                font-weight: 700;
            }
        }
    }
</style>
